import React from 'react';
import {
  border,
  color,
  layout,
  space,
  padding,
  MarginProps,
  PaddingProps,
  ColorProps,
  LayoutProps,
  BorderProps,
} from 'styled-system';
import { styled, Theme } from '@staffino/primitive-controls';
import { StyledComponent } from '@emotion/styled';

type Props = {
  theme?: Theme;
  highlight?: boolean;
};

type StyledProps = MarginProps &
  PaddingProps &
  ColorProps &
  LayoutProps &
  BorderProps;

const ChoiceTextInput: StyledComponent<
  Props &
    StyledProps &
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >
> = styled.input<Props>(
  (props) => ({
    background: 'none',
    border: `1px solid ${
      props.highlight ? props.theme.colors.primary : 'transparent'
    }`,
    outline: 'none',
    color: props.theme.colors.text,
    lineHeight: '1rem',
    fontFamily: 'inherit',
    fontSize: '1rem',
    marginLeft: -2,
  }),
  space,
  padding,
  color,
  layout,
  border,
);

export default ChoiceTextInput;
